import workshop from "../content/thumbnails/workshop.png";

export default [
  {
    title: "Introduction to Kotlin",
    path: "https://www.instagram.com/p/B1h9BO5g-x-/",
    img: workshop,
  },
];
